import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';

import { useDispatch } from '_common/hooks';

import { openModal } from '_common/modals/ModalsSlice';

import { Setting } from 'Settings/components';

import styles from './UserSecurity.module.scss';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import SessionsHeading from './SessionHeading/SessionHeading';
import SessionTable from './SessionTable/SessionTable';
import DevicesHeading from './DevicesHeading/DevicesHeading';
import DevicesTable from './DevicesTable/DevicesTable';

const UserSecurity = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <IntlErrorBoundary fallbackType="sectionHeading" mockProps={{ size: 'l', sticky: true }}>
        <SectionHeading
          size="l"
          sticky
          title={intl.formatMessage({ id: 'settings.security.password' })}
          testId="password"
        />
      </IntlErrorBoundary>
      <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 0 0' }}>
        <Setting
          style={{ alignItems: 'flex-start' }}
          label={intl.formatMessage({ id: 'settings.security.password' })}
          onEdit={() => dispatch(openModal('ChangePasswordModal'))}
          onEditLabel="global.edit"
          testId="password"
        />
      </IntlErrorBoundary>
      <IntlErrorBoundary
        fallbackType="sectionHeading"
        mockProps={{ size: 'l', sticky: true, margin: '4rem 0 0 0' }}
      >
        <SessionsHeading />
      </IntlErrorBoundary>
      <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 0 0' }}>
        <SessionTable />
      </IntlErrorBoundary>
      <IntlErrorBoundary
        fallbackType="sectionHeading"
        mockProps={{ size: 'l', sticky: true, margin: '3rem 0 0 0' }}
      >
        <DevicesHeading />
      </IntlErrorBoundary>
      <IntlErrorBoundary size="l" style={{ margin: '10rem 0 0 0' }}>
        <DevicesTable />
      </IntlErrorBoundary>
    </div>
  );
};

export default UserSecurity;
